module.exports = __webpack_public_path__ + "static/media/aniket_profile.75fc266c.jpg";